import template from './coworking-workplace-warning.jade';
import { CoworkingWorkplaceWarning } from './coworking-workplace-warning.controller';
import './coworking-workplace-warning.css';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {},
    controller: CoworkingWorkplaceWarning,
    controllerAs: 'coworkingWorkplaceWarningCtrl',
    replace: true,
  };
};
